import { StyleSheet, ActivityIndicator } from 'react-native'
import React from 'react'
import { COLORS } from '@utils/colors'

/**
 * Full-screen fallback for Suspense when loading lazy navigator chunks.
 * Does not use LoadingContext (reserved for data/API loading).
 */
export default function ChunkLoadingFallback(): React.JSX.Element {
  return (
    <ActivityIndicator
      animating
      size="large"
      style={[StyleSheet.absoluteFill, { zIndex: 100 }]}
      color={COLORS.primary.blue}
    />
  )
}
